<template>
  <div>
    <v-app-bar app flat dark color="primary">
      <v-app-bar-nav-icon
        @click.native.stop="updateUILeftDrawerState(!UILeftDrawer)"
        v-if="!screenIsWideEnough"
      ></v-app-bar-nav-icon>
      <v-toolbar-title class="ml-0 pl-3">Page Not Found</v-toolbar-title>
    </v-app-bar>
    <v-content>
      <v-layout class="calc-height" style="height: 90vh" column fill-height align-center justify-center>
        <img
          src="https://s3-eu-west-1.amazonaws.com/media.alternativebusinessfunding.co.uk/public/empty.png"
          style="opacity:0.4; min-width: 50%; max-width: 600%"
          alt=""
        />
        <p class="subtitle-1 mt-5 grey--text text--darken-2">Sorry, we couldn't find the page you were looking for.</p>
      </v-layout>
    </v-content>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'NotFound404',
  computed: {
    ...mapGetters(['UserName', 'UILeftDrawer']),
    screenIsWideEnough() {
      return this.$vuetify.breakpoint.width > 1600;
    }
  },
  methods: {
    ...mapActions(['updateUILeftDrawerState'])
  }
};
</script>

<style lang="scss" scoped>
.calc-height {
  height: calc(100vh - 64px);
  max-height: calc(100vh - 64px);
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
}
</style>
